import {
  getSelectedBoutique,
  setSelectedBoutique,
  clearSelectedBoutique,
} from '@js/utils/clickCollectStorage';
import { getUnavailableSkus } from '@js/utils/transformHyperspaceStoreData';
import {
  boutiqueToCartAttributes,
  emptyCartAttributes,
  clickCollectLineItemProperties,
  deliveryLineItemProperties,
} from '@js/utils/clickCollectCartAttributes';

export default {
  name: 'clickCollect',
  store() {
    return {
      deliveryMethod: 'delivery',
      selectedBoutique: null,
      pdpPickupBoutique: null,
      unavailableSkus: [],

      init() {
        this.selectedBoutique = getSelectedBoutique();
        if (this.selectedBoutique) {
          this.deliveryMethod = 'click_and_collect';
        }
      },

      get isClickAndCollect() {
        return this.deliveryMethod === 'click_and_collect';
      },

      get isCheckoutBlocked() {
        if (!this.isClickAndCollect) return false;
        if (!this.selectedBoutique) return true;
        return this.unavailableSkus.length > 0;
      },

      setDeliveryMethod(method) {
        this.deliveryMethod = method;
        if (method === 'delivery') {
          this.clearClickCollectState();
        }
      },

      setPdpPickupBoutique(boutique) {
        this.pdpPickupBoutique = boutique;
      },

      async applyBoutiqueSelection(boutique, skus = []) {
        this.deliveryMethod = 'click_and_collect';
        this.selectedBoutique = boutique;
        this.unavailableSkus = getUnavailableSkus(boutique, skus);
        setSelectedBoutique(boutique);

        const attributes = boutique
          ? boutiqueToCartAttributes(boutique)
          : emptyCartAttributes();

        if (window.Alpine?.store('cart')) {
          await window.Alpine.store('cart').updateAttributes(attributes);
          await window.Alpine.store('cart').updateAllLineItemProperties(
            boutique ? clickCollectLineItemProperties(boutique) : deliveryLineItemProperties()
          );
        }

        window.dispatchEvent(new CustomEvent('click-collect:boutique-selected', {
          detail: { boutique, unavailableSkus: this.unavailableSkus },
        }));
      },

      async clearClickCollectState() {
        this.selectedBoutique = null;
        this.pdpPickupBoutique = null;
        this.unavailableSkus = [];
        clearSelectedBoutique();

        if (window.Alpine?.store('cart')) {
          await window.Alpine.store('cart').updateAttributes(emptyCartAttributes());
          await window.Alpine.store('cart').updateAllLineItemProperties(deliveryLineItemProperties());
        }

        window.dispatchEvent(new CustomEvent('click-collect:cleared'));
      },
    };
  },
};
